module.exports = __webpack_public_path__ + "static/media/angle-right.fcc68b92.svg";